module.exports = __webpack_public_path__ + "static/img/KYE-FINCHER.323bd2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KYE-FINCHER.jpg
// module id = AWrN
// module chunks = 0